// extracted by mini-css-extract-plugin
export default {"btninsertar":"ListaDetallePreguntaReemplazo_btninsertar__qgsNz","contenedor_boton":"ListaDetallePreguntaReemplazo_contenedor_boton__Rvb5J"};